import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const cancel: SxStyle = {
  p: 2,
};

export const save: SxStyle = {
  p: 2,
};

export const button: SxStyle = {
  background: (p) => p.palette.grey[200],
  color: (p) => p.palette.grey[600],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  p: 1,
  ':hover': {
    color: (p) => p.palette.common.black,
  },
};
